document.addEventListener('DOMContentLoaded', () => {
  const section = document.getElementById('faq-section');
  const tabTitles = section.querySelectorAll('.product-tab-title');
  const tabDescriptions = section.querySelectorAll('.question-container');

  if (!tabTitles.length) return;

  const activateTab = (tab) => {
    const targetId = `${tab.id}-container`;
    const targetDescription = document.getElementById(targetId);

    tabTitles.forEach((t) => t.classList.remove('tab-active'));
    tabDescriptions.forEach((desc) => {
      desc.classList.remove('container-active');
      desc.setAttribute('aria-selected', 'false');
    });

    tab.classList.add('tab-active');
    if (targetDescription) {
      targetDescription.classList.add('container-active');
      targetDescription.setAttribute('aria-selected', 'true');
    }

    tab.parentElement.scrollTo({
      left: tab.offsetLeft - tab.parentElement.offsetWidth / 2 + tab.offsetWidth / 2,
      behavior: 'smooth',
    });
  };

  tabTitles.forEach((tab) => {
    tab.addEventListener('click', () => activateTab(tab));
  });

  const questions = section.querySelectorAll('.faq-question');

  questions.forEach((question) => {
    question.addEventListener('click', () => {
      questions.forEach((q) => {
        const a = q.closest('.faq-card').querySelector('.faq-answer');
        if (q !== question) a.classList.remove('answer-active');
      });

      const currentAnswer = question.closest('.faq-card').querySelector('.faq-answer');
      currentAnswer.classList.toggle('answer-active');
      question.classList.toggle('question-active');
    });
  });
});
